import { gql } from '@apollo/client';

import { CALCULATED_CREATIVE_DATA } from '../../fragments';

export const GET_CALCULATED_CREATIVE_DATA_FOR_AD_BY_AD_DETAILS = gql`
  query calculatedCreativeDataForAdByAdDetails($adDetails: [CalculateCreativeDataAdDetailsInput!]!) {
    getCalculatedCreativeDataForAdsByAdDetails(adDetails: $adDetails) {
      adId
      calculatedData {
        ...calculatedCreativeData
      }
    }
  }
  ${CALCULATED_CREATIVE_DATA}
`;
